import * as io from 'socket.io-client';

export class SocketService {
  socket: any;

  constructor() {
    this.socket = io({
      transports: ['websocket']
    });

    this.socket.on('connect', () => console.log('socket connected'));
    // this.socket.on('reconnect', () => console.log('socket connected'));
    this.socket.on('disconnect', () => console.log('socket disconnected'));
    this.socket.on('connect_error', () => console.log('socket could not connect'));
    this.socket.on('connect_timeout', () => console.log('socket could not connect'));
  }

  emit(channel: String, data: any = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      const time = new Date().getTime();
      if ((global as any).gtag) {
        (global as any).gtag('event', channel, {
          event_category: 'socket'
        });
      }
      process.env.NODE_ENV !== 'production' && console.log(`[socket] --> ${channel}`);
      this.socket.emit(channel, data, (err, d) => {
        process.env.NODE_ENV !== 'production' &&
          d &&
          console.log(`[socket] <-- ${channel}`, new Date().getTime() - time + 'ms', JSON.stringify(d).length + 'b');
        if (err) {
          reject(new Error(err));
        } else {
          resolve(d);
        }
      });
    });
  }

  subscribe(channel: String, cb) {
    this.socket.on(channel, cb);
  }
}

export default new SocketService();



// WEBPACK FOOTER //
// ./src/services/socket.service.ts